import { createAction } from "redux-act";

export const changeConfig = createAction("Change config");